import type { ChartOptions } from "chart.js";

import flowChartInflowPattern from "@/assets/images/chart-inflow-pattern.svg";
import flowChartOutflowPattern from "@/assets/images/chart-outflow-pattern.svg";

import { externalLegendHandler, externalTooltipHandler } from "./chart-plugins-handlers";

const chartBaseOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 4,
    layout: {
        padding: {
            top: 0
        }
    },
    scales: {
        x: {
            grid: {
                display: false
            }
        },
        y: {
            display: true,
            max: 10000,
            ticks: {
                count: 5
            }
        }
    },
    elements: {
        point: {
            pointStyle: false
        }
    },
    interaction: {
        intersect: false,
        mode: "nearest",
        axis: "x"
    }
};

const flowChartBaseOptions: ChartOptions = {
    ...chartBaseOptions,
    datasets: {
        bar: {
            barThickness: 16,
            borderRadius: 4
        }
    }
};

export {
    chartBaseOptions,
    flowChartBaseOptions,
    flowChartInflowPattern,
    flowChartOutflowPattern,
    externalLegendHandler,
    externalTooltipHandler
};
